import { useShallow } from 'zustand/react/shallow';

import { useDetailsStore } from '../../store/useDetailsStore';
import { DetailsStore } from '../../store/useDetailsStore/detailsStore';
import { useTypeaheadStore } from '../../store/useTypeaheadStore';
import { TypeaheadState } from '../../store/useTypeaheadStore/typeaheadStore';
import { capitalizeEachWord } from '../../utils/providerNames.utils';

interface UseGetSpecialityProps {
  primarySpeciality: string[];
}

export function useGetSpeciality({
  primarySpeciality,
}: UseGetSpecialityProps): string {
  const { specialtySearch = '' } = useDetailsStore(
    useShallow((state: DetailsStore) => ({
      specialtySearch: state.detailsState.specialtySearch,
    }))
  );

  const { searchBySpeciality } = useTypeaheadStore(
    useShallow((state: TypeaheadState) => ({
      searchBySpeciality: state.typeaheadSearchStore.searchBySpeciality,
    }))
  );

  let resultSpecialities = Array.isArray(primarySpeciality)
    ? [...primarySpeciality]
    : [];
  if (specialtySearch && searchBySpeciality !== false) {
    resultSpecialities = resultSpecialities.filter(
      (value) => value !== specialtySearch
    );
    resultSpecialities = [specialtySearch, ...resultSpecialities];
  }

  return capitalizeEachWord(resultSpecialities?.[0]) || '';
}
